// src/js/sliderInit.js

import Swiper from "swiper";
import Pagination from "swiper/modules/pagination";
import Navigation from "swiper/modules/navigation";
Swiper.use([Pagination, Navigation]);

export function initSlider() {
  const sliders = document.querySelectorAll(".mySwiper");
  sliders.forEach((slider) => {
    const nextBtn = slider.parentElement.querySelector(
      ".swiper-button-next-custom",
    );
    const prevBtn = slider.parentElement.querySelector(
      ".swiper-button-prev-custom",
    );
    // Helper to show/hide navigation based on screen size
    function updateNavVisibility(swiper) {
      const isSmallScreen = window.innerWidth < 968;
      if (isSmallScreen) {
        if (nextBtn) nextBtn.style.display = "none";
        if (prevBtn) prevBtn.style.display = "none";
      } else {
        if (!swiper.isBeginning && prevBtn) prevBtn.style.display = "";
        else if (prevBtn) prevBtn.style.display = "none";
        if (!swiper.isEnd && nextBtn) nextBtn.style.display = "";
        else if (nextBtn) nextBtn.style.display = "none";
      }
    }
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      pagination: {
        el: slider.parentElement.querySelector(".swiper-pagination"),
        clickable: true,
        type: "bullets",
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      grabCursor: true,
      loop: false,
      on: {
        afterInit(swiper) {
          updateNavVisibility(swiper);
        },
        slideChange(swiper) {
          updateNavVisibility(swiper);
        },
      },
    });
    // Listen for resize events
    window.addEventListener("resize", () => updateNavVisibility(swiper));
    // Initial check
    updateNavVisibility(swiper);
  });
}
